<template>
    <div class="px-4 pt-4 sm:px-6">
        <h3 class="col-span-2 text-base font-semibold">
            {{ $t('country_tax_residencies.tax_residency') }}
        </h3>
        <div class="divide-y divide-gray-300">
            <div v-for="(tin, index) in formValues.tax_residencies" :key="index">
                <TaxResidencyRow
                    v-model:country="tin.country"
                    v-model:no_tin_reason="tin.no_tin_reason"
                    v-model:tin="tin.tin"
                    :disabled="isLegalTaxResidenciesEditDisabled()"
                    :index="index"
                    @remove="removeRow(index)" />
            </div>
        </div>
    </div>
    <div class="px-4 sm:px-6">
        <BaseButtonPrimary :disabled="reachedTinLimit || isLegalTaxResidenciesEditDisabled()" @click="addRow()">
            <PlusIcon class="mr-2 w-6"></PlusIcon>
            {{ $t('country_tax_residencies.add_another_tax_residence') }}
        </BaseButtonPrimary>
    </div>
</template>

<script setup lang="ts">
import { TaxSituationAndResidencies } from '../forms'
import { useVModel } from '@vueuse/core'
import { computed, onMounted } from 'vue'
import { TaxResidency } from '../../../../../../utilities/account/useAccountDataPersonal'
import BaseButtonPrimary from '../../../../../base/BaseButtonPrimary.vue'
import TaxResidencyRow from '../../../form/TaxResidencyRow.vue'
import { PlusIcon } from '@heroicons/vue/outline'
import { onUnmounted } from 'vue'
import { clearIncompleteTaxResidencies } from '../../../../../../validation'
import { isLegalTaxResidenciesEditDisabled } from '../../../../../../utilities/account/useAccountDataLegal'

const props = defineProps<{
    modelValue: TaxSituationAndResidencies
}>()
const emit = defineEmits(['update:modelValue'])

const formValues = useVModel(props, 'modelValue', emit)

const reachedTinLimit = computed(() => {
    return formValues.value.tax_residencies?.length >= 5
})

function removeRow(index) {
    formValues.value.tax_residencies.splice(index, 1)
}

function addRow() {
    formValues.value.tax_residencies.push(new TaxResidency())
}

onMounted(() => {
    if (formValues.value.tax_residencies?.length === 0) {
        addRow()
    }
})

onUnmounted(() => {
    formValues.value.tax_residencies = clearIncompleteTaxResidencies(formValues.value.tax_residencies)
})
</script>
